import {useIsMobileScreen} from '@frontend/hooks/useIsMobileScreen'
import type {AdsListRouteParams} from '@frontend/modules/public/ads/AdsModuleTypes'
import {mdiFilterMenuOutline} from '@mdi/js'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {Modal} from 'swayok-react-mdb-ui-kit/components/Modal/Modal'
import {AdCategoryFiltersCard} from './AdCategoryFiltersCard'

interface Props {
    services?: boolean
}

// Кнопка, открывающая панель фильтрации на мобильных телефонах.
export function AdsCategoryFiltersPanelMobile(props: Props) {

    const isMobile = useIsMobileScreen()
    const routeParams = useParams<AdsListRouteParams>()

    const {
        services,
    } = props

    const [
        isFiltersModalVisible,
        setIsFiltersModalVisible,
    ] = useState<boolean>(false)

    if (
        !isMobile
        || !routeParams.id
        || isNaN(parseInt(routeParams.id))
    ) {
        return null
    }

    return (
        <>
            <IconButton
                path={mdiFilterMenuOutline}
                color="primary"
                className="ms-3"
                onClick={() => setIsFiltersModalVisible(true)}
            />
            <Modal
                show={isFiltersModalVisible}
                size="md"
                staticBackdrop
                closeOnEsc
                scrollable
                onClose={() => {
                    setIsFiltersModalVisible(false)
                }}
            >
                <AdCategoryFiltersCard
                    forModal
                    services={services}
                    onClose={() => setIsFiltersModalVisible(false)}
                />
            </Modal>
        </>
    )
}
